import styles from "./Shimmer.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

interface ShimmerProps {
  width?: string;
  height?: string;
  addShadow?: boolean;
  noMargin?: boolean;
}

const Shimmer: React.FC<ShimmerProps> = ({
  width = "800",
  height = "256",
  addShadow = false,
  noMargin = false,
}) => (
  <div
    className={`${noMargin ? "" : styles.card} ${addShadow ? styles.shadow : ""}`}
    style={{ width: `${width}px` }}
  >
    <div
      className={`${styles["loader-shimmer-banner"]} ${styles["shimmer-animation"]}`}
      style={{ height: `${height}px` }}
    />
  </div>
);

export default wrapperHOC(Shimmer, {
  componentName: "Shimmer-Global",
  showForChina: true,
});
